import {
  UserGroupIcon,
  HeartIcon,
  BriefcaseIcon,
} from '@heroicons/react/24/outline'

// Combined Core Values + CTO Consulting in 3-column layout
// Narrative: We listen → We commit → We lead
const features = [
  {
    name: 'We Listen First',
    description: 'Understanding your challenges deeply through transparent dialogue before writing a single line of code.',
    icon: UserGroupIcon,
    details: [
      'Discovery sessions to understand your business goals',
      'Daily standups and weekly demos keep you informed',
      'Shared dashboards give you real-time visibility',
      'Direct access to our team—no account managers in between'
    ]
  },
  {
    name: 'We Build for the Long Run',
    description: 'Architecting solutions that evolve with your business, backed by ongoing partnership and support.',
    icon: HeartIcon,
    details: [
      'Maintainable code designed for future enhancement',
      'Post-launch monitoring and rapid iteration',
      'Scaling support as your user base grows',
      'Priority access when critical issues arise'
    ]
  },
  {
    name: 'We Lead with Strategy',
    description: 'CTO-level guidance to align technology decisions with your business objectives and growth trajectory.',
    icon: BriefcaseIcon,
    details: [
      'Technology roadmaps that match your business vision',
      'Architecture reviews and technical due diligence',
      'Team scaling strategies and hiring guidance',
      'Digital transformation and modernization planning',
      'Startup-to-enterprise growth navigation'
    ]
  }
]

export default function CoreValuesServices() {
  return (
    <div className="bg-gray-900 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-4xl font-semibold tracking-tight text-pretty text-white sm:text-5xl">
            How We Work
          </h2>
          <p className="mt-6 text-lg/8 text-gray-300">
            Our approach combines deep listening, long-term thinking, and strategic technology leadership 
            to ensure your custom solutions deliver lasting value.
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {features.map((feature) => (
              <div key={feature.name} className="flex flex-col">
                <dt className="text-base/7 font-semibold text-white">
                  <div className="mb-6 flex size-10 items-center justify-center rounded-lg bg-atticusPink-600">
                    <feature.icon aria-hidden="true" className="size-6 text-white" />
                  </div>
                  {feature.name}
                </dt>
                <dd className="mt-1 flex flex-auto flex-col text-base/7 text-gray-300">
                  <p className="flex-auto mb-4">{feature.description}</p>
                  <ul className="space-y-2">
                    {feature.details.map((detail, idx) => (
                      <li key={idx} className="flex items-start text-sm">
                        <svg className="w-4 h-4 text-atticusPink-400 mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        <span className="text-gray-300">{detail}</span>
                      </li>
                    ))}
                  </ul>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
